import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "result" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row layout-responsive-6" }
const _hoisted_4 = { class: "col col-2 visual" }
const _hoisted_5 = { class: "row center-phone" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "row center-phone" }
const _hoisted_8 = { class: "col calculation-result-medium hilighted margin-bottom" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row line-phone" }, null, -1)
const _hoisted_10 = { class: "col col-1 margin-top" }
const _hoisted_11 = { class: "row layout-responsive-3 layout-result-phone-rate" }
const _hoisted_12 = { class: "col col-2" }
const _hoisted_13 = { class: "label calculation-result margin-bottom" }
const _hoisted_14 = { class: "col col-1" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "row layout-responsive-3 layout-result-phone-runtime" }
const _hoisted_17 = { class: "col col-2" }
const _hoisted_18 = { class: "label calculation-result margin-bottom" }
const _hoisted_19 = { class: "col col-1" }
const _hoisted_20 = { class: "form-line form-actions form-actions-light-yellow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_icon_base = _resolveComponent("icon-base")!
  const _component_Button = _resolveComponent("Button")!
  const _component_server_error = _resolveComponent("server-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showServerError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col amount f-left calculation-result-big hilighted", _ctx.isCalculating? 'animated-number' : '']),
                  id: "zinssatz",
                  innerHTML: this.convertNumberToHtmlWithTwoDigitsAndSuffixPercent(_ctx.gesamteffektivzins)
                }, null, 10, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.textGesamtzeffektivzins), 1),
                _createVNode(_component_tooltip, {
                  text: _ctx.textTooltipGesamteffektivzins,
                  color: "white"
                }, null, 8, ["text"])
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.textMonatlicheRate), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["amount calculation-result-medium margin-bottom", _ctx.isCalculating? 'animated-number' : '']),
                    id: "rate",
                    innerHTML: this.convertNumberToHtmlWithSuffixEuro(_ctx.monatlicheRate)
                  }, null, 10, _hoisted_15)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.textMoeglicheGesamtlaufzeit), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["amount calculation-result-medium margin-bottom", _ctx.isCalculating? 'animated-number' : '']),
                    id: "laufzeit"
                  }, _toDisplayString(_ctx.gesamtlaufzeit), 3)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Button, {
              text: _ctx.textButtonBeratung,
              design: "secondary",
              onBtnClick: _ctx.onButtonClicked,
              "tracking-category": "calc_baudarlehen",
              "tracking-action": "2_click",
              "tracking-label": "beratung"
            }, {
              iconAfter: _withCtx(() => [
                _createVNode(_component_icon_base, {
                  type: "icon",
                  name: "consultant"
                })
              ]),
              _: 1
            }, 8, ["text", "onBtnClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_server_error, {
      "error-heading": _ctx.textErrorHeading,
      "error-message": _ctx.textErrorMessage,
      show: _ctx.showServerError
    }, null, 8, ["error-heading", "error-message", "show"])
  ]))
}